import { Box } from "@mui/material";

import { getAssetPath } from "@/shared/environment";

interface IntegrationIconProps {
  size?: number;
}

export function FoxgloveIcon({ size = 32 }: IntegrationIconProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "4px",
        backgroundColor: "#5933F2",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={getAssetPath("icons/foxglove.png")}
        alt="Foxglove"
        style={{
          width: size * 0.7, // Make icon slightly smaller than container
          height: size * 0.7,
          objectFit: "contain",
        }}
      />
    </Box>
  );
}

export function S3Icon({ size = 32 }: IntegrationIconProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={getAssetPath("icons/s3.png")}
        alt="AWS S3"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
        }}
      />
    </Box>
  );
}

export function SlackIcon({ size = 32 }: IntegrationIconProps) {
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: "4px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={getAssetPath("icons/slack.png")}
        alt="Slack"
        style={{
          width: size,
          height: size,
          objectFit: "contain",
        }}
      />
    </Box>
  );
}
